module.exports = __webpack_public_path__ + "media/luxury-2026/stone-detail-960-e8680376.jpg";